export default __webpack_public_path__ + "static/media/Amazonclone.4dc975bc.png";